import ZoomableImage from '@shared/components/ZoomableImage'

const gapFillMixin = {
  data () {
    return {
      showAnswers: false,
      hasValidate: false,
      touched: []
    }
  },
  computed: {
    canValidate () {
      return this.touched.length > 0 && Object.keys(this.gaps).filter(gap => this.gaps[gap].fill === '').length === 0
    },
    isValid () {
      return Object.keys(this.gaps).filter(gap => this.gaps[gap].fill !== this.gaps[gap].goodChoice).length === 0 && !this.canValidate
    }
  },
  methods: {
    validate () {
      this.touched = []
      this.hasValidate = true
    },
    toggleTouched (gap) {
      this.touched.push(gap)
    },
    isTouched (gap) {
      return this.touched.includes(gap)
    }
  },
  components: {
    ZoomableImage
  }
}

export default gapFillMixin
